export { HeroSection, type HeroSectionProps } from './hero-section'
